import React from 'react';

export default function({
  columns=[],
  isExpandRow=false,
}){
  return (
    <thead>
      <tr>
        {isExpandRow?<th style={{width: "1px"}}></th>:<></>}
        {columns.map((col, key)=>{
          return (
            <th key={key} style={col.headerStyle}>{col.text}</th>
          );
        })}
      </tr>
    </thead>
  );
}